export const SCREEN_SM = 360;

export const SCREEN_MD = 768;

export const SCREEN_LG = 1024;

export const SCREEN_XL = 1360;
